/** A whirl (fx 'whirl'): a spin round the caster, or crashing down on the spot picked. */
import { registerFx } from './registry';

registerFx('whirl', (host) => ({
  skill: ({ src, sx, sy, tx, ty, spot }) => {
    // Around the caster, or (ground-targeted) the whirl of force crashing down on the spot.
    const [wx, wy] = spot ? [tx, ty] : [sx, sy];
    host.swingArc(src, 'spin', '255,240,210', 1.4);
    host.fx.push({ type: 'ring', x: wx, y: wy, t: 0, life: 0.45, r: 52, col: '255,240,210' });
    host.dust(wx, wy, 10, 12, 50);
    host.sfx.swing();
  },
}));
